import { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

// React-shared.
import { DEVICE_SIZES } from '@exonet/react-shared/lib/styled';

// Hooks.
import usePrevious from 'app/client/utilities/hooks/usePrevious';
import useOnOutsideClick from 'app/client/utilities/hooks/useOnOutsideClick';

export default () => {
  // Track location changes.
  const { pathname } = useLocation();
  const previous = usePrevious(pathname);

  // Keep a ref.
  const ref = useRef(null);
  const buttonRef = useRef(null);

  // Track open state;
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  // Stable: consumers hold on to it across renders.
  const handleClose = useCallback(() => setOpen(false), []);
  const handleToggle = () => setOpen(!open);

  // If the path changes, close the menu.
  useEffect(() => {
    if (previous !== null && pathname !== previous) {
      handleClose();
    }
  }, [open, handleClose, pathname, previous]);

  // If the menu is open (on mobile), disable body scroll.
  useEffect(() => {
    if (window.innerWidth < DEVICE_SIZES.XS.replace('px', '')) {
      document.body.style.overflow = open ? 'hidden' : '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  // Track outside clicks.
  useOnOutsideClick([ref, buttonRef], handleClose);

  return {
    ref,
    buttonRef,
    open,
    handleOpen,
    handleClose,
    handleToggle,
  };
};
